import { render, staticRenderFns } from "./BillingPortalRedirect.vue?vue&type=template&id=4fd92f46&"
import script from "./BillingPortalRedirect.vue?vue&type=script&lang=js&"
export * from "./BillingPortalRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports